import { createContext } from 'react'

export const havelockAuthContext = createContext(null)
